import { cn } from "@/utils/cn";
import { PropsWithChildren } from "react";

export default function ActivityIconWrapper({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) {
  return (
    <div
      className={cn(
        "h-6 w-6 flex items-center justify-center rounded-full bg-slate-100",
        className,
      )}
    >
      {children}
    </div>
  );
}
